// extracted by mini-css-extract-plugin
export default {"content":"styles_content__vmAlm","title":"styles_title__sG6IS"};